import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  ChakraProvider,
  useToast,
  Select,
  HStack,
  Divider,
  Spacer,
} from '@chakra-ui/react';
import { AppDispatch, Store } from '../Store/StoreInit';
import { useSelector, useDispatch } from 'react-redux';
import {
  IHealthPlanMaster,
  IHealthPlanType,
  IPayerAddressItem,
  IPayerMasterItem,
  IScenarioItem,
} from '../Infrastructure/Interfaces';
import axios from 'axios';
import {
  fetchHealthPlanMappingList,
  setHealthPlanPageNumber,
} from '../Store/HealthPlanMappingReducer';
import {
  fetchHealthPlanTypeList,
  fetchPayerAddressList,
  fetchSceneriosList,
  fetchUnmappedHealthPlansList,
} from '../Store/GetDropDownsValuesReducer';
import { useMsal } from '@azure/msal-react';
import { fetchPayerMasterList } from '../Store/PayerMasterReducer';

interface Props {
  isOpen?: any;
  onOpen?: any;
  onClose?: any;
  region?: any;
  pageNumber?: any;
}

const HealthPlanMappingModalPoupup: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  //const [healthplannamesunmapped, sethealthplannamesunmapped] = useState<IUnmappedHealthPlanNameItem[]>();
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const toast = useToast();
  const { instance, accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;

  // useEffect(() => {
  //   dispatch(fetchPayerMasterList());
  //   dispatch(fetchHealthPlanTypeList());
  //   dispatch(fetchSceneriosList());
  //   dispatch(fetchPayerAddressList());
  // }, []);

  var payerAddresslist: IPayerAddressItem[] = useSelector((state: any) => {
    return state.payerAddressList.payerAddressList;
  });

  var healthplantypelist: IHealthPlanType[] = useSelector((state: any) => {
    return state.healthPlanTypeList.healthPlanTypeList;
  });

  var scenariolist: IScenarioItem[] = useSelector((state: any) => {
    return state.scenariosList.scenariosList;
  });

  const [filteredAddressList, setFilteredAddressList] =
    useState(payerAddresslist);

  const [filteredScenarioList, setFilteredScenarioList] =
    useState(scenariolist);

    const arrregionlist: string[] = (process.env.REACT_APP_REGION_LIST as string).split(',');

  const [data, setdata] = useState({
    healthPlanMappingId: 0,
    healthPlanMasterId: 0,
    payerAddressId: 0,
    payerName: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    phoneNo: '',
    faxNo: '',
    displayName: '',
    isActive: true,
    healthPlanTypeId: 0,
    healthPlanType: '',
    healthPlanName: '',
    region: '',
    createdBy: '',
    createdOn: '0001-01-01T00:00:00',
    modifiedBy: '',
    modifiedOn: '0001-01-01T00:00:00',
    scenarioid: 0,
    scenarioName: '',
    deliverOption: '',
    fax_to_fax_number: '',
    isunmapped: 0,
    healthPlanId: '',
  });

  // useEffect(() =>{
  //     var scenarioitem = scenariolist.find(x => x.scenarioid == data.scenarioid);

  //     let billingsystem: string = scenarioitem?.billing_system!;
  //     let faxnumber: string = scenarioitem?.fax_to_faxnumber!;

  //     setScenarioData(prev => ({...prev, billingSystem: billingsystem, faxNumber: faxnumber}));
  // },[data.scenarioid])

  const [deliveryOption, setDeliveryOption] = useState<string[]>([]);

  useEffect(() => {
    if(scenariolist){
    const uniqueDeliveryOptions = Array.from(
      new Set(scenariolist.map(scenario => scenario.deliver_option))
    );
    setDeliveryOption(uniqueDeliveryOptions);
  }
  }, [scenariolist]);

  const [isHealthPlanNameReq, setIsHealthPlanNameReq] = useState(false);
  const [isDisplayNameReq, setIsDisplayNameReq] = useState(false);
  const payermasterlist: IPayerMasterItem[] = useSelector((state: any) => {
    return state.payerMasterList.payerMasterList;
  });

  useEffect(() => {
    Store.subscribe(() => {
      setIsHealthPlanNameReq(false);
      setIsDisplayNameReq(false);
      setdata({
        ...data,
        healthPlanMappingId:
          Store.getState().setHealthPlanMappingItem.value.healthPlanMappingId,
        healthPlanMasterId:
          Store.getState().setHealthPlanMappingItem.value.healthPlanMasterId,
        payerAddressId:
          Store.getState().setHealthPlanMappingItem.value.payerAddressId,
        address: Store.getState().setHealthPlanMappingItem.value.address,
        payerName: Store.getState().setHealthPlanMappingItem.value.payerName,
        city: Store.getState().setHealthPlanMappingItem.value.city,
        state: Store.getState().setHealthPlanMappingItem.value.state,
        zip: Store.getState().setHealthPlanMappingItem.value.zip,
        phoneNo: Store.getState().setHealthPlanMappingItem.value.phoneNo,
        faxNo: Store.getState().setHealthPlanMappingItem.value.faxNo,
        displayName:
          Store.getState().setHealthPlanMappingItem.value.displayName,
        isActive: Store.getState().setHealthPlanMappingItem.value.isActive,
        healthPlanTypeId:
          Store.getState().setHealthPlanMappingItem.value.healthPlanTypeId,
        healthPlanType:
          Store.getState().setHealthPlanMappingItem.value.healthPlanType,
        healthPlanName:
          Store.getState().setHealthPlanMappingItem.value.healthPlanName,
        region: Store.getState().setHealthPlanMappingItem.value.region,
        createdBy: Store.getState().setHealthPlanMappingItem.value.createdBy,
        createdOn: Store.getState().setHealthPlanMappingItem.value.createdOn,
        modifiedBy: Store.getState().setHealthPlanMappingItem.value.modifiedBy,
        modifiedOn: Store.getState().setHealthPlanMappingItem.value.modifiedOn,
        scenarioid: Store.getState().setHealthPlanMappingItem.value.scenarioId,
        scenarioName:
          Store.getState().setHealthPlanMappingItem.value.scenarioName,
        deliverOption:
          Store.getState().setHealthPlanMappingItem.value.deliverOption,
        fax_to_fax_number:
          Store.getState().setHealthPlanMappingItem.value.faxToFaxNumber,
        isunmapped:
          Store.getState().setHealthPlanMappingItem.value.healthPlanTypeId,
          healthPlanId:Store.getState().setHealthPlanMappingItem.value.healthPlanId,
      });
    });
  }, []);

  // useEffect(() =>{
  //     setdata({...data,
  //         scenarioid: Number(data.scenarioName.substring(0, data.scenarioName.indexOf('-'))),})
  // },[data.scenarioName])

  const handleChange = (e: any) => {
    e.preventDefault();
    const { id, value } = e.target;
    setdata(prevData => ({ ...prevData, [id]: value }));

    if (id == 'deliverOption') {
      setdata(prev => ({ ...prev, fax_to_fax_number: '' }));
    }

    if (id == 'payerAddressId') {
      var item = payerAddresslist.find(
        x =>
          x.payerAddressId ==
          (id == 'payerAddressId'
            ? value
            : data.payerAddressId)
      );
      let address = item?.address!;
      let city = item?.city!;
      let state = item?.state!;
      let zip = item?.zip!;

      setdata({
        ...data,
        healthPlanMappingId: data.healthPlanMappingId,
        payerAddressId: e.target.value,
        address: address,
        city: city,
        state: state,
        zip: zip,
      });
    }
  };

  async function handleSubmit(e: { preventDefault: () => void }) {
    e.preventDefault();
    setSaveButtonLoading(true);

    if (data.healthPlanName.trim() === '') {
      setIsHealthPlanNameReq(true);
      setIsDisplayNameReq(false);
      return;
    }
    if (data.displayName.trim() === '') {
      setIsHealthPlanNameReq(false);
      setIsDisplayNameReq(true);
      return;
    }

    const payload = {
      healthPlanMappingId: data.healthPlanMappingId,
      healthPlanMasterId: data.healthPlanMasterId,
      payerAddressId: data.payerAddressId,
      healthPlanTypeId: data.healthPlanTypeId,
      healthPlanName: data.healthPlanName,
      displayName: data.displayName.trim(),
      region: data.region,
      isActive: data.isActive,
      createdBy: userid,
      createdOn: '0001-01-01T00:00:00',
      modifiedBy: userid,
      modifiedOn: '0001-01-01T00:00:00',
      scenarioid: data.scenarioid,
      user: accounts[0].username,
      healthPlanId: data.healthPlanId
    };

    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;

    try {
      const res = await axios.get(tokenurl);
      if (res.data.success) {
        const url = `${baseurl}/Payer/${
          data.healthPlanMappingId > 0
            ? 'update_healthplanmapping'
            : 'add_healthplanmapping'
        }`;

        const axiosMethod =
          data.healthPlanMappingId > 0 ? axios.put : axios.post;

        const response = await axiosMethod(url, JSON.stringify(payload), {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${res.data.token}`,
          },
        });

        setSaveButtonLoading(false);
        dispatch(fetchUnmappedHealthPlansList(data.region));
        dispatch(fetchHealthPlanMappingList());
        props.onClose();

        if (response.data.success) {
          showToast(
            'Success',
            data.healthPlanName + ' ' + response.data.message,
            'success'
          );
        }
      }
    } catch (error: any) {
      setSaveButtonLoading(false);
      showToast(
        'Error!',
        error.toString(),
        'error'
      );
    }
  }

  function showToast(
    title: string,
    description: string,
    status: 'info' | 'warning' | 'success' | 'error' | 'loading' | undefined
  ) {
    toast({
      title,
      description,
      position: 'top',
      status,
      duration: status === 'error' ? 10000 : 5000,
      isClosable: true,
    });
  }

  useEffect(() => {
    setFilteredAddressList(
      payerAddresslist.filter(
        x => x.payerName == data.payerName && x.isActive == true
      )
    );
  }, [data.payerName]);

  useEffect(() => {
    const { deliverOption, region } = data;

    setFilteredScenarioList(
      scenariolist?.filter(
        x => x.deliver_option === deliverOption && x.billing_client === region
      )
    );
  }, [data.deliverOption]);

  useEffect(() => {
    const { deliverOption, region, fax_to_fax_number } = data;

    setFilteredScenarioList(
      scenariolist.filter(
        x =>
          x.deliver_option === deliverOption &&
          x.billing_client === region &&
          x.fax_to_faxnumber === fax_to_fax_number
      )
    );
  }, [data.fax_to_fax_number]);

  return (
    <>
      <ChakraProvider>
        <Modal
          closeOnOverlayClick={false}
          size={'3xl'}
          isOpen={props.isOpen}
          onClose={props.onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <form onSubmit={handleSubmit}>
              <ModalHeader fontWeight="bold">
                <u>Health Plan Payer Address and Scenario Mapping</u>
              </ModalHeader>
              <ModalCloseButton color="black" />{' '}
              <ModalBody pb={6}>
                <FormControl mt={2} isRequired isInvalid={isHealthPlanNameReq}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Health Plan Name:
                    </FormLabel>
                    <Input
                      size="sm"
                      isDisabled={!!data.healthPlanName}
                      placeholder="health plan name"
                      name="healthPlanName"
                      id="healthPlanName"
                      value={data.healthPlanName}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Payer Name:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="payerName"
                      id="payerName"
                      defaultValue={data.payerName}
                      onChange={e => handleChange(e)}
                    >
                      {payermasterlist?.filter(x => x.isActive).map(payer => (
                        <option key={payer.payerMasterId} value={payer.payerName}>
                          {payer.payerName}
                        </option>
                      ))}
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Payer Address:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="payerAddressId"
                      id="payerAddressId"
                      value={data.payerAddressId}
                      onChange={e => handleChange(e)}
                    >
                      {filteredAddressList?.map(address => (
                        <option key={address.payerAddressId} value={address.payerAddressId}>
                          {address.payerName} - {address.address} - {address.city} - {address.state} - ({address.zip})
                        </option>
                      ))}
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired isInvalid={isDisplayNameReq}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Display Name:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={100}
                      placeholder="Display Name"
                      name="displayName"
                      id="displayName"
                      value={data.displayName}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Plan Type:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="healthPlanTypeId"
                      id="healthPlanTypeId"
                      value={data.healthPlanTypeId}
                      onChange={e => handleChange(e)}
                      isDisabled={data.isunmapped > 0 ? true : false}
                    >
                      {healthplantypelist?.map(type => (
                        <option key={type.healthPlanTypeId} value={type.healthPlanTypeId}>
                          {type.healthPlanType}
                        </option>
                      ))}
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Address:
                    </FormLabel>
                    <Input
                      size="sm"
                      isDisabled
                      placeholder="Address"
                      name="address"
                      id="address"
                      value={data.address}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      City:
                    </FormLabel>
                    <Input
                      size="sm"
                      isDisabled
                      placeholder="City"
                      name="city"
                      id="city"
                      value={data.city}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      State:
                    </FormLabel>
                    <Input
                      size="sm"
                      isDisabled
                      placeholder="State"
                      name="state"
                      id="state"
                      value={data.state}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Zip:
                    </FormLabel>
                    <Input
                      size="sm"
                      isDisabled
                      type="text"
                      placeholder="Zip"
                      name="zip"
                      id="zip"
                      value={data.zip}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Region:
                    </FormLabel>
                    <Select
                      size="sm"
                      isDisabled={data.region != '' ? true : false}
                      placeholder="--select Region--"
                      name="region"
                      id="region"
                      defaultValue={data.region}
                      onChange={e => handleChange(e)}
                    >
                      {arrregionlist?.map(region => (
                        <option key={region} value={region}>
                          {region}
                        </option>
                      ))}
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Delivery Option:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="deliverOption"
                      id="deliverOption"
                      onChange={e => handleChange(e)}
                      defaultValue={data.deliverOption}
                    >
                      {deliveryOption?.map(option => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl
                  mt={2}
                  hidden={data.deliverOption != 'Fax' ? true : false}
                >
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Fax Number:
                    </FormLabel>
                    <Input
                      size="sm"
                      isDisabled={data.deliverOption == 'Fax' ? false : true}
                      type="text"
                      id="fax_to_fax_number"
                      placeholder="Fax to Fax Number"
                      value={data.fax_to_fax_number}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider
                  mt={2}
                  hidden={data.deliverOption != 'Fax' ? true : false}
                />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Scenario:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="scenarioid"
                      id="scenarioid"
                      onChange={e => handleChange(e)}
                      value={data.scenarioid}
                    >
                      {Array.isArray(filteredScenarioList) &&
                        filteredScenarioList.map(scenario => (
                          <option
                            key={scenario.scenarioid}
                            value={scenario.scenarioid}
                          >
                            {scenario.name}
                          </option>
                        ))}
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Active:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="isActive"
                      id="isActive"
                      defaultValue={data.isActive == false ? 'false' : 'true'}
                      onChange={e => handleChange(e)}
                    >
                      <option value="true">True</option>
                      <option value="false">False</option>
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />
              </ModalBody>
              <ModalFooter>
                <Button bg="#002677" color="white" onClick={props.onClose}>
                  Cancel
                </Button>
                <Spacer />
                <Button
                  isLoading={saveButtonLoading}
                  bg="#002677"
                  color="white"
                  mr={3}
                  type="submit"
                  //onClick={(e) => handleSubmit(e)}
                >
                  Save
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </ChakraProvider>
    </>
  );
};

export default HealthPlanMappingModalPoupup;
